import { createSlice } from "@reduxjs/toolkit";
import { elements } from "constants/types";
import { folderBy } from "layout/dictionarySearch/constants";
import * as dictionarySearchReducers from "slices/dictionarySearch/helpers";
import * as discoveryHelpers from "slices/discovery/helpers/config";

const initialState = {
  folder: { dictionary: { categories: [] }, documents: [] },
  documents: [{ dictionary: { categories: [] } }],
  content: { data: [] },
  config: {
    isSearch: false,
    folderBy: folderBy.folder,
    folderId: undefined,
    documentId: undefined,
    loading: [
      {
        element: elements.CONTENT,
        loading: false,
      },
    ],
  },
};

export const dictionarySearchSlice = createSlice({
  name: "dictionarySearch",
  initialState,
  reducers: {
    setDictionaries: (state, action) => {
      state.dictionaries = action.payload;
    },
    setSelectedFolderAndDocument: (state, action) => {
      state.config.folderId = action.payload.folderId;
      state.config.documentId = action.payload.documentId;
    },
    setFolderBy: (state, action) => {
      state.config.folderBy = action.payload;
    },
    setDataPrevLength: (state) => {
      const prevLength = state.content.data ? state.content.data.length : 0;
      state.content.previousLength = prevLength;
    },
    setContentData: (state, action) => {
      state.content.data = action.payload;
    },
    setExpandedTo: dictionarySearchReducers.setExpandedTo,
    setDocumentCheckState: dictionarySearchReducers.setDocumentCheckState,
    setCategoryCheckState: dictionarySearchReducers.setCategoryCheckState,
    setItemCheckState: dictionarySearchReducers.setItemCheckState,
    setDocCheckState: dictionarySearchReducers.setDocCheckState,
    setDocExpandState: dictionarySearchReducers.setDocExpandState,
    setAllExpandedTo: dictionarySearchReducers.setAllExpandedTo,
    setAllCheckedStateTo: dictionarySearchReducers.setAllCheckedStateTo,
    setCategories: dictionarySearchReducers.setCategories,
    setLoading: discoveryHelpers.setLoading,
  },
});

export const {
  setDictionaries,
  setSelectedFolderAndDocument,
  setFolderBy,
  setDataPrevLength,
  setContentData,
  setExpandedTo,
  setDocumentCheckState,
  setCategoryCheckState,
  setItemCheckState,
  setDocCheckState,
  setDocExpandState,
  setAllExpandedTo,
  setAllCheckedStateTo,
  setCategories,
  setLoading,
} = dictionarySearchSlice.actions;

export default dictionarySearchSlice.reducer;
